
    <ezs-statistics [status]="requestStatus" [accountFeatures]="features$ | async"></ezs-statistics>
  